export default {
  ikalaCloud: 'https://ikala.cloud',
  ikalaAi: 'https://ikala.ai',
} as const
